import * as angular from "angular";

angular
  .module('bringoz.admin.deliveries', [])
